// import React from "react";
// import { Link } from "react-router-dom";

// export default function Banner() {
//   return (
//     <section className="bg-[#0B1E39] text-white pt-28 pb-24">
//       <div className="max-w-7xl mx-auto px-4 text-center">

//         <h1 className="text-h1 md:text-6xl font-bold leading-tight">
//           Move People. Move Goods.  
//           <span className="text-[#FF9800]"> Move the Future.</span>
//         </h1>

//         <p className="mt-6 text-white/80 max-w-2xl mx-auto text-body">
//           Trusted, secure and fast transportation platform designed for India.
//         </p>

//         <div className="mt-10 flex justify-center gap-6 flex-wrap">
//           <Link to="/contact">
//               <button className="bg-[#FF9800] px-8 py-3 rounded-full font-semibold hover:opacity-90 shadow-lg">Book Now</button>
//           </Link>
//           <Link to="/contact">
//               <button className="border border-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#0B1E39] transition">Partner With Us</button>
//           </Link>
//         </div>

//       </div>
//     </section>
//   );
// }



// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Car, Truck, MapPin, ArrowRight } from "lucide-react";

// import banner1 from "../../assets/banner1.png";
// import banner2 from "../../assets/banner2.png";
// import banner3 from "../../assets/banner3.png";
// import banner4 from "../../assets/banner4.png";

// export default function Banner() {
//   const slides = [banner1, banner2, banner3, banner4];
//   const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     const slider = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(slider);
//   }, [slides.length]);

//   return (
//     <section className="relative overflow-hidden bg-gradient-to-br from-[#06152A] via-[#0E2340] to-[#071224] min-h-screen flex items-center">
//       {/* Background Glow */}
//       <div className="absolute -left-24 top-14 w-[420px] h-[420px] bg-[#FFB54D]/20 blur-[140px] rounded-full" />
//       <div className="absolute right-0 bottom-0 w-[440px] h-[440px] bg-[#3B82F6]/10 blur-[180px] rounded-full" />
//       <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/10 to-transparent" />

//       <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
//         <div className="grid lg:grid-cols-2 gap-16 items-center">
//           {/* LEFT CONTENT */}
//           <div className="space-y-8">
//             <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/10 border border-white/15 backdrop-blur-xl text-white text-sm font-medium shadow-lg shadow-[#00000030]">
//               <Car size={18} />
//               Premium transportation for modern businesses
//             </div>

//             <div className="space-y-5">
//               <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight">
//                 Move People.
//                 <br />
//                 Move Goods.
//                 <br />
//                 <span className="bg-gradient-to-r from-[#FFB54D] to-[#FF8A00] bg-clip-text text-transparent">
//                   Move the Future.
//                 </span>
//               </h1>

//               <p className="text-slate-300 text-lg max-w-2xl leading-relaxed">
//                 A premium logistics platform built for India’s fastest-growing
//                 businesses. Secure shipments, intelligent routing, and white-glove
//                 service across every mile.
//               </p>
//             </div>

        

//             <div className="flex flex-wrap gap-5 items-center">
//               <Link to="/contact">
//                 <button className="group inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-[#FFB54D] to-[#FF8A00] px-8 py-4 text-base font-semibold text-slate-950 shadow-[0_24px_50px_-36px_rgba(255,149,45,0.9)] transition-transform duration-300 hover:-translate-y-1">
//                   Book Now
//                   <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
//                 </button>
//               </Link>

//               <Link to="/contact">
//                 <button className="rounded-full border border-white/20 bg-white/10 px-8 py-4 text-base font-semibold text-white transition hover:bg-white hover:text-slate-950">
//                   Partner With Us
//                 </button>
//               </Link>
//             </div>
//           </div>

//           {/* RIGHT IMAGE */}
//           <div className="relative flex justify-center lg:justify-end">
//             <div className="relative w-full max-w-xl">
//               <div className="relative rounded-[34px] overflow-hidden border border-white/10 bg-slate-950/40 shadow-2xl shadow-[#00000040]">
//                 <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/10 to-transparent" />
//                 <img
//                   src={slides[current]}
//                   alt="Transport"
//                   className="w-full h-[520px] object-cover transition-all duration-1000"
//                 />
//                 <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#031023]/95 to-transparent">
//                   <div className="flex flex-col gap-3">
//                     <p className="text-sm uppercase tracking-[0.24em] text-slate-400">Premium Fleet</p>
//                     <h3 className="text-2xl font-bold text-white">Designed for fast, secure journeys</h3>
//                     <div className="mt-4 flex flex-wrap gap-3 text-sm text-slate-300">
//                       <span className="rounded-full border border-white/10 bg-white/10 px-3 py-1">Real-time tracking</span>
//                       <span className="rounded-full border border-white/10 bg-white/10 px-3 py-1">White-glove care</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-center gap-3 lg:justify-start">
//                 {slides.map((_, index) => (
//                   <button
//                     key={index}
//                     onClick={() => setCurrent(index)}
//                     className={`rounded-full transition-all duration-300 ${
//                       current === index
//                         ? 'w-10 h-3 bg-[#FFB54D]'
//                         : 'w-3 h-3 bg-white/30'
//                     }`}
//                   />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";
import { ArrowRight, Car } from "lucide-react";
import bannerVideo from "../../assets/trogobanner.mp4"; // Replace with your TROGO video

const Banner = () => {
  return (
    <section className="relative min-h-[100svh] lg:h-screen w-full overflow-hidden bg-[#081B33]">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover scale-105 animate-slowZoom opacity-50"
        >
          <source src={bannerVideo} type="video/mp4" />
        </video>
      </div>

      {/* Overlay */}
      {/* <div className="absolute inset-0 bg-[#081B30]/30"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#081B30] via-transparent to-[#102A4A]/50"></div> */}

      {/* Glow */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-[#FF9800]/10 via-transparent to-orange-400/10 animate-pulse pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 flex items-center min-h-[100svh] max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center w-full">
          
          {/* LEFT CONTENT */}
          <div className="max-w-3xl lg:col-span-7 space-y-6">
            {/* Tagline */}
            <span className="inline-block text-[#FF9800] uppercase tracking-[3px] text-sm font-bold animate-slideUp">
              India’s Trusted Transport Platform
            </span>

            {/* Heading */}
            <h1 className="font-extrabold text-white leading-[1.05] text-4xl sm:text-5xl lg:text-6xl animate-slideUp delay-200">
              Every Ride. <br />
              Every Delivery. <br />
              <span className="text-[#FF9800]">One Platform.</span>
            </h1>

            {/* Description */}
            <p className="text-gray-200 text-lg max-w-xl leading-relaxed animate-fadeIn delay-500">
              TROGO connects riders, drivers, and logistics partners through one powerful ecosystem. 
              Secure, fast, and reliable transport solutions across India.
            </p>

            {/* Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-5 animate-fadeIn delay-700">
              <a
                href="https://trogo-bucket.s3.ap-south-1.amazonaws.com/Trogo-Passanger.apk" // Replace with actual APK link
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="group bg-[#FF9800] hover:bg-orange-500 text-white px-8 py-4 rounded-2xl font-semibold text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:scale-105">
                  Download Passenger App
                  <ArrowRight
                    size={20}
                    className="group-hover:translate-x-1 transition"
                  />
                </button>
              </a>

              <a
                href="https://trogo-bucket.s3.ap-south-1.amazonaws.com/Trogo-Driver.apk" // Replace with actual APK link
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="group border border-white/30 bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-semibold text-lg transition-all duration-300 flex items-center gap-3 hover:bg-white hover:text-[#081B33] shadow-md">
                  Download Driver App
                  <ArrowRight
                    size={20}
                    className="group-hover:translate-x-1 transition"
                  />
                </button>
              </a>
            </div>
          </div>

          {/* RIGHT FLOATING CARD */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end animate-fadeIn delay-700">
            <div className="relative group bg-white/10 backdrop-blur-xl border border-white/20 p-8 rounded-3xl shadow-2xl w-full max-w-sm transform hover:-translate-y-2 transition-all duration-500">
              {/* Glow */}
              <div className="absolute -right-10 -top-10 w-24 h-24 bg-[#FF9800]/20 rounded-full blur-2xl group-hover:bg-[#FF9800]/40 transition-all duration-500" />
              
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-[#FF9800]/20 rounded-xl text-[#FF9800]">
                  <Car size={24} />
                </div>
                <span className="text-xs uppercase tracking-widest text-gray-300 font-bold">
                  TROGO Features
                </span>
              </div>
              
              <h3 className="text-2xl font-black text-white tracking-tight leading-tight">
                Fast. <br />
                <span className="text-[#FF9800]">Reliable.</span> <br />
                Secure.
              </h3>
              
              <p className="text-sm text-gray-300 mt-3 font-medium leading-snug">
                From passenger rides to logistics deliveries, TROGO ensures seamless transport solutions across India.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#081B33] via-[#081B33]/40 to-transparent pointer-events-none"></div>
    </section>
  );
};

export default Banner;
